import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import { gettext } from '@eb/i18n';
import { CrossChunky as CrossChunkySvg } from '@eb/eds-iconography';
import { IconButton } from '@eb/eds-icon-button';

import { handleRemoveFilter as handleRemoveFilterAction } from '../../../../redux/actions/search';
import FilterButton from './FilterButton';
import OverlayContext from '../../../../context/Overlay';

/**
 * A simple filter button shown to indicate when search results are filtered
 * by Organization Id for Credit redemption. User interaction is limited to
 * toggle on/off.  When clicked, a dialog appears to prompt the user to
 * Keep the filter applied or remove it. Selecting or changing
 * organizations is not possible.
 */

const removeFilterMessage = gettext(
    'If you remove this filter, you will no longer see only events hosted by this organizer. To view these search results again, go back to <a href="/u/credits/" rel="noopener noreferrer" target="_blank">the Credits page</a>.',
);

const overlayOptions = (props) => ({
    message: (
        <span
            //eslint-disable-next-line
            dangerouslySetInnerHTML={{
                __html: removeFilterMessage,
            }}
        />
    ),
    primaryText: gettext('Remove'),
    secondaryText: gettext('Keep'),
    onPrimaryAction: () => {
        props.handleRemoveFilter({ organizationsOr: true });
        props.setOverlayConfig(null);
    },
    onSecondaryAction: () => props.setOverlayConfig(null),
    title: '',
});

const OrganizationFilterButton = (props) => {
    const { setOverlayConfig } = useContext(OverlayContext);

    return (
        <li className="filter-panel__drawers__item eds-l-pad-top-6 eds-l-pad-bot-5">
            <FilterButton
                isActive={true}
                onClick={() =>
                    setOverlayConfig({
                        overlayType: 'dialoge',
                        ...overlayOptions({ ...props, setOverlayConfig }),
                    })
                }
                value="creditsForOrganizerFilter"
            >
                <div>
                    <div className="filter-panel__drawers__item__sub-header">
                        {gettext('Only show events')}
                    </div>
                    <div className="filter-panel__drawers__item__header">
                        {gettext('that accept this credit')}
                    </div>
                </div>
            </FilterButton>
            <div className="filter-panel__drawers__item--close-btn">
                <IconButton
                    title={gettext('Remove organization credits filter')}
                    iconType={<CrossChunkySvg />}
                    iconColor="ui-blue"
                    onClick={() =>
                        setOverlayConfig({
                            overlayType: 'dialog',
                            ...overlayOptions({ ...props, setOverlayConfig }),
                        })
                    }
                />
            </div>
        </li>
    );
};

OrganizationFilterButton.propTypes = {
    handleRemoveFilter: PropTypes.func,
    hideOverlay: PropTypes.func,
    showOverlay: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    handleRemoveFilter: (...args) =>
        dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
});

const enhance = compose(withRouter, connect(undefined, mapDispatchToProps));

export default enhance(OrganizationFilterButton);
